import { render, staticRenderFns } from "./single-branch.vue?vue&type=template&id=05897fda&scoped=true"
import script from "./single-branch.vue?vue&type=script&lang=js"
export * from "./single-branch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05897fda",
  null
  
)

export default component.exports